import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'

import HotelInfoAccordion from './HotelInfoAccordion';
import store from 'js/components/shared/store'
export * from './customEvents'

export default function (el) {
  const root = ReactDOM.createRoot(el);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <HotelInfoAccordion />
      </Provider>
    </React.StrictMode>
  );
}
